import { Icon } from "@material-ui/core";
import yellownote from "../resources/yellow-note.png";

const TodoIcon = () => {
  return <Icon component="img" src={yellownote} fontSize="large" />;
};

export default TodoIcon;
